import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import isEmpty from 'lodash/isEmpty';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faPlay from '@fortawesome/fontawesome-free-solid/faPlay';
import faStop from '@fortawesome/fontawesome-free-solid/faStop';
import { assignTrackUrlToken } from '../../../../helpers/episodeTrack';
import Loading from '../../../../components/Loading';
import styles from '../shared/styles';

class Audioplayer extends Component {

  constructor(props) {
    super(props);

    this.state = {
      url: '',
      isPlaying: false,
      currentTime: 0,
      duration: 0,
    };

    this.audio = null;
    this.timerInterval = null;

    this.handlePlayback = this.handlePlayback.bind(this);
  }

  componentDidMount() {
    this.assignPlayerUrl();
  }

  componentWillUnmount() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  handlePlayback() {
    const { isPlaying } = this.state;
    const action = (isPlaying) ? 'pause' : 'play';
    const toState = (isPlaying) ? {
      isPlaying: false,
      currentTime: 0,
    } : {
      isPlaying: true,
    };

    this.setState({
      ...toState,
    }, () => {
      this.audio[action]();

      // reset current timer
      if (action === 'pause') {
        this.audio.currentTime = 0;
      }
    });
  }

  isLoading() {
    const { url } = this.state;
    return isEmpty(url);
  }

  assignPlayerUrl() {
    return new Promise(async (resolve, reject) => {
      try {
        const { source, public: publicEpisode } = this.props;
        if (!isEmpty(source)) {
          // assign restriction
          const newurl = await assignTrackUrlToken({
            url: source,
            publicEpisode
          });

          this.setState({
            url: newurl,
          }, () => {
            // update timer
            this.timerInterval = setInterval(() => {
              if (this.audio) {
                const { currentTime = 0, duration = 0 } = this.audio;
                this.setState({
                  currentTime,
                  duration,
                });
              }
            }, 1000);

            resolve();
          });
        }
      } catch (e) {
        reject(new Error(e.message));
      }
    });
  }

  renderAudioSource() {
    const { url } = this.state;
    if (isEmpty(url)) {
      return null;
    }

    return (
      <audio preload="auto" ref={audio => (this.audio = audio)}>
        <source src={url} />
      </audio>
    );
  }

  renderAudioSeeker() {
    const { currentTime = 0, duration = 0 } = this.state;
    if (this.isLoading() || !duration) {
      return (
        <Loading
          type="circle"
          align="left"
          size={30}
          fontSize={1.4}
          fill="#b3b3b3"
        />
      );
    }

    const fromValue = moment.duration(currentTime ? currentTime : 0, 'seconds');
    const toValue = moment.duration(duration ? duration : 0, 'seconds');
    const from = moment.utc(fromValue.asMilliseconds()).format('HH:mm:ss');
    const to = moment.utc(toValue.asMilliseconds()).format('HH:mm:ss');
    return `${from} / ${to}`;
  }

  render() {
    const { isPlaying, duration = 0 } = this.state;
    const { label } = this.props;

    const playbackBtns = () => {
      const icon = (isPlaying) ? faStop : faPlay;
      return (
        <FloatingActionButton
          backgroundColor="#eb4f40"
          onClick={this.handlePlayback}
          disabled={this.isLoading() || !duration}
        >
          <div style={styles.miniPlayBackBtn}>
            <FontAwesomeIcon icon={icon} color="white" inverse="true" size="2x" />
          </div>
        </FloatingActionButton>
      );
    };

    return (
      <div style={{ padding: 20, marginTop: 10 }}>
        <span style={styles.playbackHeadText}>{label}</span>
        <div style={styles.playbackInnerWrapper}>
          <div style={styles.playbackDivision}>
            <MuiThemeProvider>
              {playbackBtns()}
            </MuiThemeProvider>
          </div>
          <div style={styles.playbackDivision}>
            {this.renderAudioSource()}
          </div>
          <div style={styles.playbackDivision}>
            <div style={styles.playbackTimer}>
              {this.renderAudioSeeker()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Audioplayer.propTypes = {
  label: PropTypes.string,
  source: PropTypes.string,
  public: PropTypes.bool,
};

Audioplayer.defaultProps = {
  label: '',
  source: '',
  public: false,
};

export default Audioplayer;
